export default __webpack_public_path__ + "static/media/record.f48b482c.svg";